module.exports = __webpack_public_path__ + "img/man.c5b82d2b.png";